import { ref, reactive } from "vue";

export const config = ref({
  templateId: null,
  templateType: null,
});

export const uipApp = reactive({});
